module.exports = __webpack_public_path__ + "img/download.8887e37c.svg";